let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eLZz0")).then(() => parcelRequire('eXvfk'));